var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"value":_vm.value,"placeholder":`${_vm.$tc('select')} ${_vm.$tc('year')}`,"expanded":_vm.expanded},on:{"input":function($event){return _vm.onSelect($event)}}},_vm._l((_vm.options),function(option){return _c('option',{key:option,domProps:{"value":option}},[_vm._v(" "+_vm._s(option)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }